import * as React from 'react';
import Warning from '../../../../components/Warning';
import Loading from '../../../../components/Loading';
import { getTaxpayerCsvLink } from '../../services/API';
import { Link } from 'redux-little-router';
import { getLkFileHref } from '../../../../utils';

export default class LoadingCashierCheck extends React.Component {
  state = {
    isLoading: false,
    isError: false,
    serverFileNames: null,
  };

  createTaxpayerCsvLink = async () => {
    this.setState({ isLoading: true });
    const { isOk, data } = await getTaxpayerCsvLink();

    if (isOk) {
      this.setState({ serverFileNames: data, isLoading: false });
    } else {
      this.setState({ error: true, isLoading: false });
    }
  };

  renderDownLoadLink() {
    const { isLoading, isError } = this.state;
    if (isError) {
      return (
        <div>
          <Warning />
        </div>
      );
    }
    return (
      <div>
        {isLoading ? (
          <div className="link">
            Идет выгрузка данных. Пожалуйста подождите.
            <div className="loading-container__downloadPaymentLink">
              <Loading />
            </div>
          </div>
        ) : (
          <a className="link" onClick={() => this.createTaxpayerCsvLink()}>
            Выгрузить данные по НП
          </a>
        )}
      </div>
    );
  }

  render() {
    const { serverFileNames } = this.state;
    return (
      <div>
        {this.renderDownLoadLink()}
        {serverFileNames && (
          <div key={`csv`} className="cRow">
            <div className="cCol">
              <Link href={getLkFileHref(serverFileNames)} target="_blank">
                {serverFileNames.serverFileName}
              </Link>
            </div>
          </div>
        )}
      </div>
    );
  }
}
